import React from 'react';
import { bool, func } from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import DuplicatePartnerFormContainer from './DuplicatePartnerFormContainer';

const { Body, Header, Title } = Modal;

export default function DuplicatePartnerModal({ handleClose, showModal }) {
  return (
    <Modal show={showModal} onHide={handleClose}>
      <Header>
        <Title className="pull-left">
          It looks like you may have already signed up
        </Title>
        <Button className="close pull-right" onClick={handleClose}>
          <FontAwesome name="times" tag="i" />
        </Button>
      </Header>
      <Body>
        <p>
          You already have an eLocal affiliate account. If you would like to
          provide us with any updates to your status or how you think we can
          work together, please let us know.
        </p>
        <DuplicatePartnerFormContainer />
      </Body>
    </Modal>
  );
}

DuplicatePartnerModal.propTypes = {
  handleClose: func.isRequired,
  showModal: bool.isRequired
};
